import React, { useEffect, useRef, useState } from 'react'
import CoachLayout from "../../layouts/CoachLayout";
import MenuLayout from "../../layouts/MenuLayout";
import { useNavigate } from 'react-router-dom';
import { coachPaths } from '../../routes/coach';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCoachList } from '../../redux/features/coach/actions/coachAction';
import Loader from '../../components/loader';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import { curSym } from '../../utils/pip';

const FullJob = () => {
  const user = { name: "founder-coaching", role: "coach" };
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach)
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  //   const [navBarDemo, setNavBarDemo] = useState("Founder");

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    dispatch(fetchCoachList());
  }, []);

  const displayUsers = coachList?.filter((item) => {
    const matchCoachingType = item?.category_name
      ?.toLowerCase()
      .includes("founder");
    return matchCoachingType;
  });

  if (isLoading2) {
    return <Loader />;
  }

  return (
    <MenuLayout user={user}>
      <section
        class="ct_px_40   py-5"
        style={{ backgroundColor: "var(--dark_blue)" }}
      >
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-md-12  mb-4 mb-md-0 "
              data-aos="fade-down"
              data-aos-duration="1500"
            >
              <div class="ct_px_40 ct_px_0_767 text-center text-white">
                <h2 class="ct_fs_50_new ct_mb_20 mx-auto ">
                  Senior full stack engineer, User onboarding
                </h2>
                <p class="mb-0 ct_fs_24_new mx-auto">
                  We are looking for a senior full stack engineer to transform
                  design that drive business conversion
                </p>
                <div class="ct_mt_20">
                  <a
                    class="ct_yellow_btn mx-auto  px-5 ct_fit_content  ct_w_100_575"
                    data-bs-target="#ct_aaply_for_job"
                    data-bs-toggle="modal"
                  >
                    Apply Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ct_px_40 ct_mt_60">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="ct_outline_bg px-0">
                <h2 className="ct_fs_32 ct_darkblue_text ct_mb_30 ct_px_20">
                  Employment Information
                </h2>

                <ul className="ct_emp_info_card_list ct_border_top_light ct_px_20 pt-4 ct_para_scroll ct_custom_scroll">
                  <li>
                    <p className="mb-1 ct_grey_text ct_fs_16">Industry</p>
                    <p className="mb-1 ct_grey_text ct_text_op_7 ct_fs_14">
                      Technology
                    </p>
                  </li>
                  <li>
                    <p className="mb-1 ct_grey_text ct_fs_16">Salary</p>
                    <p className="mb-1 ct_grey_text ct_text_op_7 ct_fs_14">
                      {curSym} 2k to {curSym} 4k USD
                    </p>
                  </li>
                  <li>
                    <p className="mb-1 ct_grey_text ct_fs_16">Experience</p>
                    <p className="mb-1 ct_grey_text ct_text_op_7 ct_fs_14">
                      2 - 1 Years
                    </p>
                  </li>
                  <li>
                    <p className="mb-1 ct_grey_text ct_fs_16">Job Type</p>
                    <p className="mb-1 ct_grey_text ct_text_op_7 ct_fs_14">
                      Part-Time
                    </p>
                  </li>
                  <li>
                    <p className="mb-1 ct_grey_text ct_fs_16">Location</p>
                    <p className="mb-1 ct_grey_text ct_text_op_7 ct_fs_14">
                      London, England
                    </p>
                  </li>
                  <li>
                    <p className="mb-1 ct_grey_text ct_fs_16">Category</p>
                    <p className="mb-1 ct_grey_text ct_text_op_7 ct_fs_14">
                      Senior Full Stack Developer
                    </p>
                  </li>
                  <li>
                    <p className="mb-1 ct_grey_text ct_fs_16">Qualification</p>
                    <p className="mb-1 ct_grey_text ct_text_op_7 ct_fs_14">
                      Computer Science
                    </p>
                  </li>
                  <li>
                    <p className="mb-1 ct_grey_text ct_fs_16">Job Type</p>
                    <p className="mb-1 ct_grey_text ct_text_op_7 ct_fs_14">
                      Part-Time
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ct_px_40 ct_mt_60">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-8 col-lg-8 mb-4 mb-lg-0">
              <div className="">
                <h4 className="ct_fs_30 ct_mb_20 ct_darkblue_text">
                  About this role
                </h4>
                <p
                  className="ct_fs_20_new ct_para_scroll ct_custom_scroll ct_darkblue_text"
                  style={{ maxWidth: "820px" }}
                >
                  As a UI/UX designer on CodeNest, you’ll focus on design user-
                  friendly on several platform (web, mobile, dashboards, etc) to
                  our user needs. Your innovation solution will enhance the user
                  experience on several platforms. Join us and let’s making
                  impact on user engagement at CodeNest.
                </p>
              </div>
              <div className="ct_mt_40">
                <h4 className="ct_fs_30 ct_mb_20 ct_darkblue_text">
                  Qualification
                </h4>
                <ul
                  className="ps-4 ct_para_scroll ct_custom_scroll"
                  style={{ listStyle: "disc" }}
                >
                  <li className="ct_fs_20_new ct_darkblue_text">
                    At least 2-4 years of relevant experience in product design
                    or related roles.
                  </li>
                  <li className="ct_fs_20_new ct_darkblue_text mt-1">
                    Knowledge of design validation, either through quantitative
                    or qualitative research.
                  </li>
                  <li className="ct_fs_20_new ct_darkblue_text mt-1">
                    Have good knowledge using Figma and Figjam
                  </li>
                  <li className="ct_fs_20_new ct_darkblue_text mt-1">
                    Experience with analytics tools to gather data from users
                  </li>
                </ul>
              </div>
              <div className="ct_mt_40">
                <h4 className="ct_fs_30 ct_mb_20 ct_darkblue_text">
                  Responsibility
                </h4>
                <ul
                  className="ps-4 ct_para_scroll ct_custom_scroll"
                  style={{ listStyle: "disc" }}
                >
                  <li className="ct_fs_20_new ct_darkblue_text">
                    Create design and user journey on every features and
                    product/business units across multiple devices (Web +App)
                  </li>
                  <li className="ct_fs_20_new ct_darkblue_text mt-1">
                    Identifying design problems through user journey and
                    devising elegant solutions
                  </li>
                  <li className="ct_fs_20_new ct_darkblue_text mt-1">
                    Develop low and hi fidelity designs, user experience flow, &
                    prototype, translate it into highly- polished visual
                    composites following style and brand guidelines
                  </li>
                  <li className="ct_fs_20_new ct_darkblue_text mt-1">
                    Brainstorm and works together with Design Lead, UX
                    Engineers, and PMS to execute a design sprint on specific
                    story or task
                  </li>
                </ul>
              </div>
              <div className="ct_mt_40">
                <h4 className="ct_fs_30 ct_mb_20 ct_darkblue_text">
                  Requirement
                </h4>
                <ul
                  className="ps-4 ct_para_scroll ct_custom_scroll"
                  style={{ listStyle: "disc" }}
                >
                  <li className="ct_fs_20_new ct_darkblue_text">
                    Proven work experience as a UI/UX Designer or similar role
                  </li>
                  <li className="ct_fs_20_new ct_darkblue_text mt-1">
                    Strond portfolio of design projects (web/ mobile)
                  </li>
                  <li className="ct_fs_20_new ct_darkblue_text mt-1">
                    Proficiency in design and prototyping tools such as Figma,
                    Adobe XD, Sketch, or similar
                  </li>
                  <li className="ct_fs_20_new ct_darkblue_text mt-1">
                    Good understanding of HTML/CSS (Knowledge of front-end
                    development is a plus)
                  </li>
                  <li className="ct_fs_20_new ct_darkblue_text mt-1">
                    Ability to think creatively and deliver within deadlines
                  </li>
                  <li className="ct_fs_20_new ct_darkblue_text mt-1">
                    Excellent communication and teamwork skills
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 mb-4 mb-lg-0 ps-lg-5">
              <div>
                <h4 className="ct_fs_24_new">Similar Jobs</h4>
                <ul>
                  <li className="mt-4">
                    <div class="ct_simillar_job_card gap-3">
                      <div className="d-flex align-items-center justify-content-between gap-2">
                        <div className="d-flex align-items-center gap-3">
                          <div class="ct_feature_job_icon">
                            <img src="assets/img/Featured_Jobs_icon_6.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                              Lead UI Designer
                            </h4>
                            <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                              <li className="ct_fs_14">CodeNest</li>
                              <li className="ct_fs_14">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                London, England
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="ct_bookmark_circle">
                          <svg
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                              stroke="#023047"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <circle
                              cx="16.6667"
                              cy="16.6667"
                              r="16.1667"
                              stroke="#535862"
                            />
                          </svg>
                        </div>
                      </div>

                      <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          Full-Time
                        </span>
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          Remote
                        </span>
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          2-4 Years
                        </span>
                      </div>

                      <div className="d-flex align-items-center gap-3">
                        <p className="ct_grey_text  ct_fs_14 mb-0">
                          2 day ago{" "}
                        </p>
                        <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                        <p className="ct_grey_text ct_fs_14 mb-0">
                          120 Applicants
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="mt-4">
                    <div class="ct_simillar_job_card gap-3">
                      <div className="d-flex align-items-center justify-content-between gap-2">
                        <div className="d-flex align-items-center gap-3">
                          <div class="ct_feature_job_icon">
                            <img src="assets/img/Featured_Jobs_icon_3.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                              Sr. UX Designer
                            </h4>
                            <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                              <li className="ct_fs_14">CodeNest</li>
                              <li className="ct_fs_14">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                London, England
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="ct_bookmark_circle">
                          <svg
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                              stroke="#023047"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <circle
                              cx="16.6667"
                              cy="16.6667"
                              r="16.1667"
                              stroke="#535862"
                            />
                          </svg>
                        </div>
                      </div>

                      <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          Full-Time
                        </span>
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          Remote
                        </span>
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          2-4 Years
                        </span>
                      </div>

                      <div className="d-flex align-items-center gap-3">
                        <p className="ct_grey_text  ct_fs_14 mb-0">
                          2 day ago{" "}
                        </p>
                        <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                        <p className="ct_grey_text ct_fs_14 mb-0">
                          120 Applicants
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="mt-4">
                    <div class="ct_simillar_job_card gap-3">
                      <div className="d-flex align-items-center justify-content-between gap-2">
                        <div className="d-flex align-items-center gap-3">
                          <div class="ct_feature_job_icon">
                            <img src="assets/img/Featured_Jobs_icon_1.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                              Lead UI Designer
                            </h4>
                            <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                              <li className="ct_fs_14">CodeNest</li>
                              <li className="ct_fs_14">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                London, England
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="ct_bookmark_circle">
                          <svg
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                              stroke="#023047"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <circle
                              cx="16.6667"
                              cy="16.6667"
                              r="16.1667"
                              stroke="#535862"
                            />
                          </svg>
                        </div>
                      </div>

                      <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          Full-Time
                        </span>
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          Remote
                        </span>
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          2-4 Years
                        </span>
                      </div>

                      <div className="d-flex align-items-center gap-3">
                        <p className="ct_grey_text  ct_fs_14 mb-0">
                          2 day ago{" "}
                        </p>
                        <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                        <p className="ct_grey_text ct_fs_14 mb-0">
                          120 Applicants
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="mt-4">
                    <div class="ct_simillar_job_card gap-3">
                      <div className="d-flex align-items-center justify-content-between gap-2">
                        <div className="d-flex align-items-center gap-3">
                          <div class="ct_feature_job_icon">
                            <img src="assets/img/Featured_Jobs_icon_1.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                              Sr. UX Designer
                            </h4>
                            <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                              <li className="ct_fs_14">CodeNest</li>
                              <li className="ct_fs_14">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                London, England
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="ct_bookmark_circle">
                          <svg
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                              stroke="#023047"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <circle
                              cx="16.6667"
                              cy="16.6667"
                              r="16.1667"
                              stroke="#535862"
                            />
                          </svg>
                        </div>
                      </div>

                      <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          Full-Time
                        </span>
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          Remote
                        </span>
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          2-4 Years
                        </span>
                      </div>

                      <div className="d-flex align-items-center gap-3">
                        <p className="ct_grey_text  ct_fs_14 mb-0">
                          2 day ago{" "}
                        </p>
                        <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                        <p className="ct_grey_text ct_fs_14 mb-0">
                          120 Applicants
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="mt-4">
                    <div class="ct_simillar_job_card gap-3">
                      <div className="d-flex align-items-center justify-content-between gap-2">
                        <div className="d-flex align-items-center gap-3">
                          <div class="ct_feature_job_icon">
                            <img src="assets/img/Featured_Jobs_icon_1.svg" />
                          </div>
                          <div>
                            <h4 className="ct_fs_18 mb-2 ct_darkblue_text">
                              Jr. UI Designer
                            </h4>
                            <ul class="ct_similar_job_key_points d-flex align-items-center gap-3 flex-wrap">
                              <li className="ct_fs_14">CodeNest</li>
                              <li className="ct_fs_14">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7.58625 16.3582C8.04075 16.7332 8.51475 17.076 9 17.4105C9.4863 17.0804 9.95799 16.7293 10.4137 16.3582C11.1735 15.7344 11.8885 15.058 12.5535 14.334C14.0865 12.6577 15.75 10.2277 15.75 7.5C15.75 6.61358 15.5754 5.73583 15.2362 4.91689C14.897 4.09794 14.3998 3.35382 13.773 2.72703C13.1462 2.10023 12.4021 1.60303 11.5831 1.26381C10.7642 0.924594 9.88642 0.75 9 0.75C8.11358 0.75 7.23583 0.924594 6.41689 1.26381C5.59794 1.60303 4.85382 2.10023 4.22703 2.72703C3.60023 3.35382 3.10303 4.09794 2.76381 4.91689C2.42459 5.73583 2.25 6.61358 2.25 7.5C2.25 10.2277 3.9135 12.657 5.4465 14.334C6.11146 15.0583 6.82647 15.7342 7.58625 16.3582ZM9 9.9375C8.35353 9.9375 7.73355 9.68069 7.27643 9.22357C6.81931 8.76645 6.5625 8.14646 6.5625 7.5C6.5625 6.85353 6.81931 6.23355 7.27643 5.77643C7.73355 5.31931 8.35353 5.0625 9 5.0625C9.64647 5.0625 10.2665 5.31931 10.7236 5.77643C11.1807 6.23355 11.4375 6.85353 11.4375 7.5C11.4375 8.14646 11.1807 8.76645 10.7236 9.22357C10.2665 9.68069 9.64647 9.9375 9 9.9375Z"
                                    fill="#023047"
                                  />
                                </svg>
                                London, England
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="ct_bookmark_circle">
                          <svg
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 22.4833V15.589C10 12.5611 10 11.0472 10.9763 10.1066C11.9526 9.16602 13.524 9.16602 16.6667 9.16602C19.8093 9.16602 21.3807 9.16602 22.357 10.1066C23.3333 11.0472 23.3333 12.5611 23.3333 15.589V22.4833C23.3333 24.4049 23.3333 25.3657 22.6893 25.7096C21.4421 26.3755 19.1027 24.1537 17.9917 23.4847C17.3473 23.0967 17.0252 22.9027 16.6667 22.9027C16.3082 22.9027 15.986 23.0967 15.3417 23.4847C14.2307 24.1537 11.8912 26.3755 10.644 25.7096C10 25.3657 10 24.4049 10 22.4833Z"
                              stroke="#023047"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <circle
                              cx="16.6667"
                              cy="16.6667"
                              r="16.1667"
                              stroke="#535862"
                            />
                          </svg>
                        </div>
                      </div>

                      <div class="d-flex align-items-center gap-4 ct_mb_20 mt-4">
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          Full-Time
                        </span>
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          Remote
                        </span>
                        <span
                          class="ct_py_5_px_10 ct_border_radius_5 d-inline-block ct_fs_16 ct_darkblue_text"
                          style={{ backgroundColor: "hsl(0deg 0% 93% / 50%)" }}
                        >
                          2-4 Years
                        </span>
                      </div>

                      <div className="d-flex align-items-center gap-3">
                        <p className="ct_grey_text  ct_fs_14 mb-0">
                          2 day ago{" "}
                        </p>
                        <p className="ct_grey_text ct_fs_14 mb-0 ct_dot_5"></p>
                        <p className="ct_grey_text ct_fs_14 mb-0">
                          120 Applicants
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        data-aos="fade-left"
        data-aos-duration="1500"
        class="ct_looking_for_work_bg ct_mb_100     ct_p_111_y_106 ct_mt_100"
        style={{ backgroundColor: "#219EBC", paddingLeft: "121px" }}
      >
        <div class="d-flex align-items-center gap-lg-4 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4">
              Discover Roles at Game-Changing Companies
            </h4>
            <p class="mb-0 ct_fs_18 ct_fw_300">
              Discover roles from innovative brands shaping the future of work.
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a
              class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
              onClick={() => navigate(coachPaths?.ContactUs)}
            >
              Explore Jobs
            </a>
          </div>
        </div>
      </section>

      <div
        className="modal modal-lg ct_congratulation_modal_fade"
        id="ct_aaply_for_job"
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h4 className="ct_fs_32 ct_darkblue_text mb-0">UI/UX Designer</h4>
              <button
                type="button"
                className="btn-close ct_circle_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body px-0 ct_mt_60 pt-0">
              <form className="ct_modal_scroll ct_custom_scroll px-4 pb-3 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Full Name
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="e.g"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Email Address
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Email address"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Phone Number
                      </label>
                      <input
                        type="number"
                        className="form-control ct_input"
                        placeholder="Phone number"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Expected Salary (in local currency)
                      </label>
                      <input
                        type="number"
                        className="form-control ct_input"
                        placeholder="Expected salary"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Work
                      </label>
                      <div className="d-flex flex-column gap-2 position-relative">
                        <select className="form-control ct_input">
                          <option>Hourly</option>
                          <option>Hourly</option>
                          <option>Hourly</option>
                          <option>Hourly</option>
                        </select>
                        <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Current Position (if unemployed, then “Unemployed”)
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Current position"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Linkedin Profile Link
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Link"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Porfolio Link
                      </label>
                      <input
                        type="text"
                        className="form-control ct_input"
                        placeholder="Link"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Cover Letter
                      </label>
                      <textarea
                        className="form-control ct_input h-auto"
                        rows={4}
                        placeholder="Type here..."
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Upload Resume
                      </label>
                      <div
                        class="ct_upload_product_main ct_upload_product_main_180 "
                        style={{ height: "118px" }}
                      >
                        <svg
                          width="33"
                          height="33"
                          viewBox="0 0 33 33"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.87174 22.0167C4.26376 20.9403 3.20508 19.1073 3.20508 17.027C3.20508 13.9023 5.59376 11.3354 8.64473 11.0528C9.26883 7.25653 12.5654 4.36035 16.5384 4.36035C20.5114 4.36035 23.808 7.25653 24.4321 11.0528C27.4831 11.3354 29.8717 13.9023 29.8717 17.027C29.8717 19.1073 28.8131 20.9403 27.2051 22.0167M11.2051 21.6937L16.5384 16.3604M16.5384 16.3604L21.8717 21.6937M16.5384 16.3604V28.3604"
                            stroke="#9CA3AF"
                            stroke-width="2.66667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>

                        <p class="text-center ct_fs_18 ct_text_op_07 mb-0">
                          Upload your resume here
                        </p>
                        <label for="ct_upload_product">
                          <input
                            type="file"
                            name=""
                            id="ct_upload_product"
                            class="d-none"
                          />
                        </label>
                      </div>

                      <div class="ct_single_uploaded_img mt-3 d-none">
                        <img
                          src="assets/img/Why_Be_Part_of_NUVIO_left_img.png"
                          alt=""
                        />
                        <i class="fa-solid fa-xmark"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center gap-3 justify-content-end pt-4">
                  <button
                    className="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 py-2"
                    style={{ borderColorL: "#53586252" }}
                    type="button"
                  >
                    Save Draft
                  </button>
                  <button
                    className="ct_sky_blue_btn ct_yellow_btn px-5 py-2"
                    data-bs-target="#ct_submit_modal"
                    data-bs-toggle="modal"
                    type="button"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade ct_submit_modal"
        id="ct_submit_modal"
        tabindex="-1"
        aria-labelledby="ct_submit_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div className="modal-header border-0 pb-0">
              <button
                type="button"
                className="btn-close ct_circle_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div class="modal-body py-4">
              <div class="mx-auto d-block text-center mb-4">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.57031 26.2031V45.4856H42.4328V26.2031L24.0016 35.3681L5.57031 26.2031Z"
                    fill="#FFB703"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.57031 18.1328V23.2628L24.0016 32.4241L42.4328 23.2628V18.1328H5.57031Z"
                    fill="#FFB703"
                  />
                  <path
                    d="M23.9436 23.355L15.0898 11.2725H20.6136V0H27.2211V11.2725H32.8011L23.9436 23.355Z"
                    fill="#FB8500"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_20 ct_fw_600">Application Sent! 🎉</h4>
                <p className="mx-auto" style={{ maxWidth: "401px" }}>
                  Your application has been successfully submitted. The client
                  will review your profile and get back to you soon
                </p>
              </div>
              <div class="text-center mt-4">
                <button
                  class="ct_yellow_btn ct_h_48 mx-auto px-5 w-100"
                  data-bs-dismiss="modal"
                >
                  Go Back to Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MenuLayout>
  );
}

export default FullJob